import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale, LinearScale, PointElement, LineElement,
  Tooltip, Legend,
} from "chart.js";

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Tooltip, Legend);

export default function LineChartCard({ title, labels, data }) {
  const chartData = {
    labels,
    datasets: [{ label: "Completed", data }],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: { legend: { display: true } },
  };

  return (
    <div className="card shadow-sm h-100">
      <div className="card-body">
        <div className="fw-semibold mb-2">{title}</div>
        <div style={{ height: 280 }}>
          <Line data={chartData} options={options} />
        </div>
      </div>
    </div>
  );
}